import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { subscriptionTiers } from '../services/subscriptionService';
import '../styles/LimitReachedModal.css';

const LimitReachedModal = ({ show, onClose, limitType = 'property_analysis' }) => {
  const navigate = useNavigate();
  const { subscription } = useSubscription();
  
  if (!show) return null;

  const currentTier = subscriptionTiers[subscription?.tier || 'FREE'];
  const nextTiers = Object.entries(subscriptionTiers).filter(
    ([key, tier]) => tier.propertyAnalyses > currentTier.propertyAnalyses || tier.propertyAnalyses === -1
  );

  const handleUpgrade = (tierKey) => {
    onClose();
    navigate('/subscription', { 
      state: { 
        highlightTier: tierKey,
        from: 'limit-reached' 
      }
    });
  };

  const getLimitLabel = () => {
    switch (limitType) {
      case 'property_analysis':
        return 'property analyses';
      case 'chat_message':
        return 'chat messages';
      default:
        return 'analyses';
    }
  };

  return (
    <div className="limit-modal-overlay">
      <div className="limit-modal">
        <div className="limit-modal-header">
          <h3>Monthly Limit Reached</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="limit-modal-content">
          <div className="limit-icon">📊</div>
          <p className="limit-message">
            You've reached your monthly limit of <strong>{currentTier.propertyAnalyses}</strong> {getLimitLabel()} 
            on the <strong>{currentTier.name}</strong> plan.
          </p>
          <p className="limit-description">
            Upgrade your plan to continue analyzing properties and get unlimited access to all features.
          </p>
          
          {nextTiers.length > 0 && (
            <div className="upgrade-options">
              <h4>Choose your upgrade:</h4>
              <div className="tier-cards">
                {nextTiers.map(([tierKey, tier]) => (
                  <div key={tierKey} className="tier-card">
                    <div className="tier-name">{tier.name}</div>
                    <div className="tier-price">${tier.price}/month</div>
                    <div className="tier-limit">
                      {tier.propertyAnalyses === -1 ? 'Unlimited' : tier.propertyAnalyses} analyses
                    </div>
                    <button 
                      className="upgrade-btn"
                      onClick={() => handleUpgrade(tierKey)}
                    >
                      Upgrade Now
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        
        <div className="limit-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default LimitReachedModal;